import {WidgetEventStruct} from '../../widget-event.struct';
import {FirmwareWidgetEnum} from '../../../enums';

export class FirmwareWidgetEventStruct extends WidgetEventStruct {
  public event_firmware_widget_type: FirmwareWidgetEnum;
} // end Package
